module.exports = __webpack_public_path__ + "img/avatar-shader.8e2b4170.svg";